import Component from '../classes/component';

const CLASSES = {
  burgerActive: 'is-active',
  expanded: {
    mobile: 'is-expanded--mobile',
  },
};

const SELECTORS = {
  burger: '#burger',
};

class Header extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  private _toggleMobile() {
    this._getChild('burger').classList.toggle(CLASSES.burgerActive);
    this.container.classList.toggle(CLASSES.expanded.mobile);
  }

  protected _onEnter() {
    this._addListener('burger', 'click', this._toggleMobile.bind(this));
  }
}

export default Header;
